import { CombinedState, combineReducers } from 'redux'
import bankLoginReducer, {
	BankLoginState,
} from './consumerDataPullSessionReducers/bankLoginReducer'
import bankSessionReducer, {
	BankSessionState,
} from './consumerDataPullSessionReducers/bankSessionReducer'
import closeConsumerDataPulLSessionReducer, {
	CloseConsumerDataPullSessionState,
} from './consumerDataPullSessionReducers/closeConsumerDataPullSessionReducer'
import consumerAuthenticationReducer, {
	ConsumerAuthenticationState,
} from './consumerDataPullSessionReducers/consumerAuthenticationReducer'
import {
	consumerSessionDataReducer,
	ConsumerSessionDataState,
} from './consumerDataPullSessionReducers/consumerSessionDataReducer'
import fetchBankSessionsTransactionsReducer, {
	FetchBankSessionsTransactionsState,
} from './consumerDataPullSessionReducers/fetchBankSessionsTransactionsReducer'
import psd2ConsentReducer, {
	Psd2ConsentState,
} from './consumerDataPullSessionReducers/psd2ConsentReducer'
import redirectWindowReducer from './redirectWindowReducer'

export interface RootState {
	consumerAuthentication: ConsumerAuthenticationState
	psd2Consent: Psd2ConsentState
	bankLogin: BankLoginState
	bankSessions: BankSessionState
	closeConsumerDataPullSession: CloseConsumerDataPullSessionState
	consumerSessionData: ConsumerSessionDataState
	fetchBankSessionsTransactionsState: FetchBankSessionsTransactionsState
}

export default (): CombinedState<any> => {
	const rootReducer = combineReducers({
		consumerAuthentication: consumerAuthenticationReducer,
		psd2Consent: psd2ConsentReducer,
		consumerSessionData: consumerSessionDataReducer,
		closeConsumerDataPullSession: closeConsumerDataPulLSessionReducer,
		bankLogin: bankLoginReducer,
		bankSessions: bankSessionReducer,
		redirectWindow: redirectWindowReducer,
		fetchBankSessionsTransactionsState: fetchBankSessionsTransactionsReducer,
	})
	return rootReducer
}
